var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"attend-dash"},[(_vm.empAttends)?_c('attend-table',{attrs:{"empAttends":_vm.empAttends}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }